export default __webpack_public_path__ + "static/media/Billon.3dade4d9.png";